export default __webpack_public_path__ + "assets/ico_rule_on_black-d899472b.svg";